import * as types from "../ActionType";
import axios from "axios";
import { notifyError, notifysuccess } from "../../components/general/Notification";
import { hasExpirition } from "../../components/general/general-component/abstruct-component/useExpirition";
const END_POINT = process.env.REACT_APP_BASE_URL;

const get = (arr, type) => {
    return ({
        type: type,
        payload: arr
    })
}
const add = (type) => {
    return ({
        type: type
    })
}
const delelte = (type) => {
    return ({
        type: type
    })
}
const edit = (type) => {
    return ({
        type: type
    })
}

export const postRequest = (cartArr,files,state, setLoad) => {
    return function (dispatch) {
        setLoad(true)
        let token = localStorage.getItem("tokenA");
        const body = {
            general_info: {
                requester_id: state?.requester_id,
                request_date: state?.request_date,
                needed_on: state?.needed_on,
                notes: state?.notes,
                warehouse_id: state?.warehouse_id,
                received_by: state?.received_by,
                phone_number: state?.phone_number,
                company_project_id: state?.company_project_id,
                request_number: state?.request_number,
                ship_to: state?.ship_to,
                location: state?.location,
                status: state?.status,
            },
            request_items: cartArr,
            files: files
        }
        console.log(body)
        axios.post(`${END_POINT}/api/materials-requests`, body, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status === "Success") {
                dispatch(add(types.ADD_REQUEST));
                //dispatch(loadWarehouses());
                notifysuccess(res.data.message)
                setLoad(false)
            }
        }).catch((err) => {
            setLoad(false)
            notifyError(err.response.data.message)
        })
    }
}
export const loadRequests = () => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${END_POINT}/api/users`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(get(res.data.data, types.GET_REQUESTS));
            }
        }).catch((err) => {
            notifyError(err.response.data.message)
        })
    }
}

export const deleteRequest = (id, setloadDel, setIsDeleted, setIdDeleted) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        setloadDel(true)
        axios.delete(`${END_POINT}/api/users/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(delelte(types.DELETE_REQUEST));
                notifysuccess(res.data.message)
                setIsDeleted('deleted')
                setIdDeleted(id)
                setloadDel(false)
            }
        }).catch((err) => {
            setloadDel(false)
            notifyError(err.response.data.message)
        })
    }
}

export const putRequest = (id, name, city, country, location, phone_number, notes, status, setLoad) => {
    return function (dispatch) {
        setLoad(true)
        let token = localStorage.getItem("tokenA");
        axios.put(`${END_POINT}/api/users/${id}`,
            name, city, country, location, phone_number, status, notes
            , {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }).then((res) => {
                if (res.data.status === "Success") {
                    dispatch(edit(types.EDIT_REQUEST));
                    dispatch(loadRequests());
                    notifysuccess(res.data.message)
                    setLoad(false)
                }
            }).catch((err) => {
                setLoad(false)
                notifyError(err.response.data.message)
            })
    }
}


export const filterRequest = (name, email, role, setLoad) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA")
        setLoad(true);
        const queryParams = [];
        if (name !== '') queryParams.push(`filters[name]=${name}`);
        if (email !== '') queryParams.push(`filters[email]=${email}`);
        if (role !== '') queryParams.push(`filters[role]=${role}`);
        const finalQuery = queryParams.join('&');
        const apiUrl = `${END_POINT}/api/users?${finalQuery}`;
        axios.get(apiUrl, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then((res) => {
            setLoad(false);
            dispatch(get(res.data.data, types.GET_REQUESTS));
        }).catch((err) => {
            ;
            setLoad(false);
        });
    };
};


